import { render, staticRenderFns } from "./UserDetailsLoanHistory.vue?vue&type=template&id=1e1b8e6d&"
import script from "./UserDetailsLoanHistory.vue?vue&type=script&lang=js&"
export * from "./UserDetailsLoanHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports